import { render, staticRenderFns } from "./PageStats.vue?vue&type=template&id=56b668d8&"
import script from "./PageStats.vue?vue&type=script&lang=ts&"
export * from "./PageStats.vue?vue&type=script&lang=ts&"
import style0 from "./PageStats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports